import { Component, OnInit } from '@angular/core';
import {Message} from "primeng/primeng";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Separado} from "./separado";
import {SeparadoService} from "../Services/separado.service";
import {DetalleSeparado} from "./separadoDetalle";
import {ClienteService} from "../Services/clientes.service";
import {Cliente} from "../cliente/cliente";
import {TiendaService} from "../Services/tienda.service";
import {Tienda} from "../tienda/tienda";
import {ListaPrecioService} from "../Services/listaPrecio.service";
import {ListaPrecio} from "../lista-precio/listaPrecio";
import {ComboService} from "../Services/combo.service";
import {Combo} from "../combo/combo";
import {Producto} from "../producto/producto";
import {PagoSeparado} from "./pagoSeparado";
import {UrlService} from "../Services/url.service";

@Component({
  selector: 'app-separado',
  templateUrl: './separado.component.html',
  styleUrls: ['./separado.component.css']
})
export class SeparadoComponent implements OnInit {

  msgs: Message[] = [];
  formSeparado : FormGroup;
  formPagoSeparado : FormGroup;
  btnNuevo = true;
  btnCancelar = false;
  btnGuardar = false;
  btnNuevaPagoSeparado = true;
  btnCancelarPagoSeparado = false;
  btnGuardarPagoSeparado = false;
  btnGuardarEditar = false;
  panelRequeridos = false;
  loading = false;
  SeparadosRegistrados:Separado[];
  SeparadoSeleccionado:Separado;
  tipoGuardado = '';
  panelPagoSeparado = false;
  verDetalleSeparadosAsignados = false;
  DetalleSeparadosRegistrados:DetalleSeparado[];
  ClientesRegistrados:Cliente[];
  TiendasRegistrados:Tienda[];
  ProductosRegistrados:ListaPrecio[];
  CombosRegistrados:Combo[];
  PagosRegistrados:PagoSeparado[];
  tabla = '';


  constructor(private URL:UrlService,
              private servicioCliente:ClienteService,
              private servicioTienda:TiendaService,
              private servicioSeparado:SeparadoService,
              private servicioLista:ListaPrecioService,
              private servicioCombo:ComboService,
              private fb: FormBuilder) { }

  ngOnInit() {
    this.crearControlesSeparado();
    this.crearControlesPagoSeparado();
    this.CancelarPagoSeparado();
    this.listarSeparados();
    this.listarClientes();
    this.listarTiendas();

  }

  crearControlesSeparado(){
    this.formSeparado = this.fb.group({
      cliente_id:[''],
      tienda_id:[''],
      total:[''],
      saldo:[''],
      fechaRetiro:[''],
      estado:[''],
      }
    );

  }
  crearControlesPagoSeparado(){
    this.formPagoSeparado = this.fb.group({
      separado_id:[''],
      valorPago:[''],
      }
    );

  }
  nuevoSeparado(){
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnGuardarEditar = false;
    this.btnCancelar = true;
    this.formSeparado.enable();
    this.formSeparado.reset();
    this.panelRequeridos = true;
    this.tipoGuardado = 'guardar';

  }
  Cancelar(){
    this.btnGuardar = false;
    this.btnNuevo = true;
    this.btnCancelar = false;
    this.btnGuardarEditar = false;
    this.formSeparado.reset();
    this.formSeparado.disable();
    this.panelRequeridos = false;
    this.tabla='';
  }
  mensajes(severity,summary,detail){
    this.msgs = [];
    this.msgs.push({severity:severity, summary:summary, detail:detail});
  }
  guardarNuevoSeparado(){
    if(this.tipoGuardado == 'editar'){
      this.loading = true;
      this.servicioSeparado.putSeparado(this.formSeparado.value,this.SeparadoSeleccionado['Separado'].id)
        .subscribe(
          rt => {
            this.mensajes('success','Actualizacion',rt);
            this.listarSeparados();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    else if(this.tipoGuardado == 'guardar') {
      this.loading = true;
      this.servicioSeparado.addSeparado(this.formSeparado.value)
        .subscribe(
          rt => {
            this.mensajes('success','Guardar',rt);
            this.listarSeparados();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    this.tipoGuardado = '';
  }
  listarSeparados(){
    this.loading = true;
    this.servicioSeparado.getSeparado()
      .subscribe(
        rt => {
          this.SeparadosRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  seleccionarSeparado(item:Separado){
    this.btnNuevo = false;
    this.btnGuardar = false;
    this.btnGuardarEditar = true;
    this.btnCancelar = true;
    this.formSeparado.enable();
    this.panelRequeridos = true;
    this.SeparadoSeleccionado = item;
    this.SeparadoDetalle(item);
    this.tipoGuardado = 'editar';
    this.listarDetalleSeparados(item);
    this.listarPagosSeparados();
    this.listarCombos();
    this.listarProductos();
    this.verDetalleSeparadosAsignados = true;
    this.tabla = 'ui-grid-col-9';

  }
  SeparadoDetalle(item:Separado):void {
    this.formSeparado.patchValue({
      id:item.id,
      cliente_id:item.cliente_id,
      tienda_id:item.tienda_id,
      total:item.total,
      saldo:item.saldo,
      fechaRetiro:item.fechaRetiro,
      estado:item.estado
    });
  }
  guardarNuevaPagoSeparado(){
    this.loading = true;
    this.formPagoSeparado.patchValue({
      separado_id:this.SeparadoSeleccionado.id
    });

    this.servicioSeparado.asignarPagoSeparado(this.formPagoSeparado.value)
      .subscribe(
        rt => {
          this.mensajes('success','Guardar',rt);
          this.listarDetalleSeparados(this.SeparadoSeleccionado);
          this.listarSeparados();
          this.listarPagosSeparados();
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
          this.Cancelar();
        });
  }
  nuevaPagoSeparado(){
    this.btnNuevaPagoSeparado = false;
    this.btnGuardarPagoSeparado = true;
    this.btnCancelarPagoSeparado = true;
    this.formPagoSeparado.enable();
    this.formPagoSeparado.reset();
    this.panelPagoSeparado = true;
  }
  CancelarPagoSeparado(){
    this.btnGuardarPagoSeparado = false;
    this.btnNuevaPagoSeparado = true;
    this.btnCancelarPagoSeparado = false;
    this.formPagoSeparado.reset();
    this.formPagoSeparado.disable();
    this.panelPagoSeparado = false;
    this.verDetalleSeparadosAsignados = false;
    this.tabla='';
  }
  listarDetalleSeparados(item:Separado){
    this.loading = true;
    this.servicioSeparado.getDetallesBySeparado(item.id)
      .subscribe(
        rt => {
          this.DetalleSeparadosRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        });
  }
  listarClientes(){
    this.loading = true;
    this.servicioCliente.getCliente()
      .subscribe(
        rt => {
          this.ClientesRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  listarTiendas(){
    this.loading = true;
    this.servicioTienda.getTienda()
      .subscribe(
        rt => {
          this.TiendasRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  listarCombos(){
    this.loading = true;
    this.servicioCombo.getComboByTienda(this.SeparadoSeleccionado.tienda_id)
      .subscribe(
        rt => {
          this.CombosRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  listarProductos(){
    this.loading = true;
    this.servicioLista.getListaByTienda(this.SeparadoSeleccionado.tienda_id)
      .subscribe(
        rt => {
          this.ProductosRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  listarPagosSeparados(){
    this.loading = true;
    this.servicioSeparado.getPagosBySeparado(this.SeparadoSeleccionado.id)
      .subscribe(
        rt => {
          this.PagosRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  imprimirSeparado(separado){
    let url:string = this.URL.getLocal()+'/separado/imprimir/'+separado.id;
    window.open(url,'blank');
  }


}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/separado/separado.component.ts